'use strict'

const dialogScript = () => {
    const buttons = document.querySelectorAll('[data-dialog-authenticate-id]')
    const closeButton = document.querySelectorAll('[data-dialog-authenticate-close]')
    const switchLoginButton = document.querySelector('[data-dialog-authenticate-switch-login]')
    const switchRegisterButton = document.querySelector(
        '[data-dialog-authenticate-switch-registreren]'
    )
    const switchRegister2Button = document.querySelector(
        '[data-dialog-authenticate-switch-registreren2]'
    )
    const switchHerstelButton = document.querySelector(
        '[data-dialog-authenticate-switch-herstel]'
    )
    const body = document.querySelector('body')

    const openDialog = (dialogId) => {
        const dialog = document.getElementById(dialogId)

        if (dialog) {
            body.classList.add('overflow-hidden')
            dialog.showModal()
        }
    }

    const closeDialog = (dialog) => {
        if (dialog) {
            body.classList.remove('overflow-hidden')
            dialog.close()
        }
    }

    if (switchLoginButton) {
        switchLoginButton.addEventListener('click', () => {
            const dialog = switchLoginButton.closest('dialog')
            closeDialog(dialog)
            openDialog('dialog__registreren')
        })
    }

    if (switchRegisterButton) {
        switchRegisterButton.addEventListener('click', () => {
            const dialog = switchRegisterButton.closest('dialog')
            closeDialog(dialog)
            openDialog('dialog__login')
        })
    }

    if (switchRegister2Button) {
        switchRegister2Button.addEventListener('click', () => {
            const dialog = switchRegister2Button.closest('dialog')
            closeDialog(dialog)
            openDialog('dialog__login')
        })
    }

    if (switchHerstelButton) {
        switchHerstelButton.addEventListener('click', () => {
            const dialog = switchHerstelButton.closest('dialog')
            closeDialog(dialog)
            openDialog('dialog__herstel')
        })
    }

    if (buttons) {
        buttons.forEach((button) => {
            button.addEventListener('click', () => {
                const dialogId = button.getAttribute('data-dialog-authenticate-id')
                openDialog(dialogId)
        })

        button.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault()

                const dialogId = button.getAttribute('data-dialog-authenticate-id')
                openDialog(dialogId)
            }
            })
        })
    }

    if (closeButton) {
        closeButton.forEach((button) => {
            button.addEventListener('click', () => {
                const dialog = button.closest('dialog')
                closeDialog(dialog)
            })
        })
    }

    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
            const openDialogs = document.querySelectorAll('dialog[open]')

            openDialogs.forEach((dialog) => {
                closeDialog(dialog)
            })
        }
    })

    document.querySelectorAll('dialog').forEach((dialog) => {
        dialog.addEventListener('click', (event) => {
            const rect = dialog.getBoundingClientRect()
            const isInDialog =
                event.clientX >= rect.left &&
                event.clientX <= rect.right &&
                event.clientY >= rect.top &&
                event.clientY <= rect.bottom
            if (!isInDialog) {
                closeDialog(dialog)
            }
        })
    })

    const loginForm = document.getElementById('login-form')

    if (loginForm) {
        loginForm.addEventListener('submit', (event) => {
            event.preventDefault()

        const formData = new FormData(loginForm)

        fetch('/auth/login', {
            method: 'POST',
            body: formData
        })
        .then(response => response.json())
        .then(data => {
            if (data.success) {
                closeDialog(loginForm.closest('dialog'))
                location.reload()
            }

            if (data.errors) {
                const errorMessage = data.errors.login
                const errorElement = loginForm.querySelector('[data-login-error]')
                if (errorElement) {
                    errorElement.textContent = errorMessage
                }
            }
            });
        })
    }

    const registerForm = document.getElementById('register-form')

    if (registerForm) {
        registerForm.addEventListener('submit', (event) => {
            event.preventDefault()

        const formData = new FormData(registerForm)

        fetch('/auth/register', {
            method: 'POST',
            body: formData
        })
        .then(response => response.json())
        .then(data => {
            if (data.success) {
                closeDialog(registerForm.closest('dialog'))
                window.location.href="/registratie-voltooid";
            }

            if (data.errors) {
                const errorMessage = data.errors.register
                const errorElement = registerForm.querySelector('[data-register-error]')
                if (errorElement) {
                        errorElement.textContent = errorMessage
                    }
                }
            })
        })
    }

    const herstelForm = document.getElementById('herstel-form')

    if (herstelForm) {
        herstelForm.addEventListener('submit', (event) => {
            event.preventDefault()

        const formData = new FormData(herstelForm)

        fetch('/auth/forgot-password', {
            method: 'POST',
            body: formData
        }).then(response => response.json())
            .then(data => {
                const errorElement = herstelForm.querySelector('[data-herstel-error]')

                if (data.success) {
                    errorElement.textContent = 'Als het account bij ons bekend is, dan is een wachtwoord herstel link daarheen verstuurd.'
                }

                if (data.errors) {
                    const errorMessage = data.errors.forgotPassword
                    errorElement.textContent = errorMessage
                }
            })
        });
    }
}

export const authenticate = (() => {
    const init = () => {
        dialogScript()
    }

    return { init }
})()
